import { AccountType } from 'mycorems-app-accounts';

export default {
  ADD_CLIENT: {
    scope: 'client',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  EDIT_CLIENT: {
    scope: 'client',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  FIND_CLIENTS: {
    scope: 'client',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  FIND_EXTERNAL_CLIENTS: {
    scope: 'client',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  SETUP_AGENCY: {
    scope: 'settings',
    accountTypes: [AccountType.AGENCY],
  },
  SETUP_COMPANY: {
    scope: 'settings',
    accountTypes: [AccountType.COMPANY],
  },
  FIND_ACCOUNT: {
    scope: '',
  },
  FIND_ACCOUNTS: {
    scope: '',
    accountTypes: [AccountType.SERVICE_PROVIDER, AccountType.AGENCY],
  },
  PURCHASE_CREDITS: {
    scope: 'credit',
  },
  FIND_ACCOUNT_PRICE_LEVEL: {
    scope: 'credit',
  },
  FIND_ACCOUNT_PRICE_LEVELS: {
    scope: 'credit',
  },
  ENABLE_CUSTOM_FIELDS: {
    scope: 'settings',
  },
  ENABLE_DISABLE_AUTO_RENEW: {
    scope: 'settings',
  },
  UPDATE_ACCOUNT_SETTINGS: {
    scope: 'settings',
  },
  FIND_ACCOUNT_SETTINGS: {
    scope: 'settings:read',
  },
  FETCH_CAMPAIGN: {
    scope: 'campaign',
  },
  FETCH_CAMPAIGNS: {
    scope: 'campaign',
  },
  FIND_EMAIL_CAMPAIGN: {
    scope: '',
  },
  FIND_EMAIL_CAMPAIGNS: {
    scope: '',
  },
  GENERATE_REPORT: {
    scope: 'report',
  },
  UPDATE_REPORT_NOTES: {
    scope: 'report',
  },
  SUBMIT_REPORT_NOTES: {
    scope: 'report',
    accountTypes: [AccountType.AGENCY],
  },
  CREATE_PRICE_LEVEL: {
    scope: 'price',
    accountTypes: [AccountType.SERVICE_PROVIDER],
  },
  EDIT_PRICE_LEVEL: {
    scope: 'price',
    accountTypes: [AccountType.SERVICE_PROVIDER],
  },
  FIND_PRICE_LEVEL: {
    scope: '',
  },
  FIND_PRICE_LEVELS: {
    scope: '',
  },
  SHOW_SIDEBAR: {
    accountTypes: [AccountType.AGENCY],
  },
  CLIENT_CONFIG: {
    accountTypes: [AccountType.AGENCY],
  },
  CLIENT_SUMMARY: {
    accountTypes: [AccountType.AGENCY],
  },
  COMPANY_CONFIG: {
    scope: 'settings',
    accountTypes: [AccountType.COMPANY],
  },
  COMPANY_SUMMARY: {
    scope: 'campaign',
    accountTypes: [AccountType.COMPANY],
  },
  VIEW_COMPANY_CAMPAIGNS: {
    scope: 'campaign',
    accountTypes: [AccountType.COMPANY],
  },
  VIEW_CLIENT_CAMPAIGNS: {
    accountTypes: [AccountType.AGENCY],
  },
};
